exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__NewWindowIcon__root {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__NewWindowIcon__root {\n  display: inline-block;\n  margin-left: 6px;\n  cursor: inherit;\n}\n\n  .DS__NewWindowIcon__root svg {\n    -webkit-transform: translateY(-3px);\n            transform: translateY(-3px);\n  }\n", ""]);

// exports
exports.locals = {
	"root": "DS__NewWindowIcon__root"
};